import { MapGroupId } from "../../types";
import img from "../../mapImages/InterchangeHiddenStashes.webp";

const mapData = {
  groupId: MapGroupId.Interchange,
  groupName: {
    en: "Interchange",
    ru: "Развязка ",
  },
  title: {
    en: "Hidden Stashes",
    ru: "Тайники",
  },
  imgPath: img,
  extracts: [],
};

export default mapData;
